module.exports = __webpack_public_path__ + "img/grid-solid.1cee7ea8.svg";